module.exports = __webpack_public_path__ + "app/community/list-communities-1MOwU4lw.html";